"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function pophealthFact(name, geographies, altName = undefined, fk = []) {
    let fact = {
        name,
        altName,
        tableType: 'fact',
        grain: [
            'zip-geo:' + geographies[0],
            'year::key',
        ],
        tableGrain: [
            geographies[0],
            'year_key',
        ],
        foreignKeys: [...fk],
    };
    if (geographies.length > 1)
        fact.joins = geographies.slice(1).map(geo => 'zip-geo:' + geo);
    return fact;
}
function pophealthGeoFact(name, geo) {
    let fact = {
        name,
        tableType: 'fact',
        grain: [],
        tableGrain: [
            '!' + geo,
            'year_key',
        ],
        foreignKeys: [
            geo + '::key',
        ],
    };
    return fact;
}
const acsPopulation = pophealthFact('acs-population', ['fips', 'cbsa', 'state_fips'], 'acs-pop');
const apmMetrics = pophealthGeoFact('apm-metrics', 'county');
const brfss = {
    name: 'brfss',
    tableType: 'fact',
    grain: [
        'zip-geo:fips',
        'year::key'
    ],
    joins: [
        'zip-geo:mmsa',
        'zip-geo:state_fips'
    ],
    tableGrain: [
        'fips',
        '!cbsa',
        'year_key'
    ],
    foreignKeys: [
        'cbsa::key'
    ]
};
const cbsaMarketConc = pophealthGeoFact('cbsa-market-concentration', 'cbsa');
const crBenchmarks = {
    name: 'commercial-reimbursement-benchmarks',
    tableType: 'fact',
    grain: [
        'zip-geo:cbsa'
    ],
    tableGrain: ['cbsa'],
    foreignKeys: [],
};
const countyMarketConc = pophealthGeoFact('county-market-concentration', 'county');
const crmCd = {
    name: 'crm-cd',
    tableType: 'fact',
    grain: [
        'year::key',
        'cd_id',
    ],
    tableGrain: [
        'year_key',
        'cd_id',
    ],
    foreignKeys: [],
};
const biCrmCd = {
    name: 'bi-crm-cd',
    tableType: 'fact',
    grain: [
        'year::key',
        'cd_id'
    ],
    tableGrain: [
        'year_key',
        'cd_id'
    ],
    foreignKeys: [
        'congressional-district::key'
    ],
};
const crmCounty = pophealthFact('crm-county', ['fips']);
const biCrmCounty = {
    name: 'bi-crm-county',
    tableType: 'fact',
    grain: [
        'zip-geo:fips',
        'year::key'
    ],
    tableGrain: [
        'year_key',
        'fips'
    ],
    foreignKeys: [
        'county::key'
    ],
};
const crmNational = {
    name: 'crm-national',
    tableType: 'fact',
    grain: [
        'year::key',
    ],
    tableGrain: ['year_key'],
    foreignKeys: ['country::key'],
};
const biCrmNational = {
    name: 'bi-crm-national',
    tableType: 'fact',
    grain: [
        'year::key',
    ],
    tableGrain: ['year_key'],
    foreignKeys: ['country::key'],
};
const crmState = pophealthFact('crm-state', ['state_fips']);
const biCrmState = {
    name: 'bi-crm-state',
    tableType: 'fact',
    grain: [
        'zip-geo:state_fips',
        'year::key',
    ],
    tableGrain: [
        'year_key',
        'state_fips'
    ],
    foreignKeys: [
        'state::key'
    ],
};
const medicareCostVariation = pophealthFact('medicare-cost-variation', ['cbsa']);
const medicareGeoVariation = pophealthGeoFact('medicare-geographic-variation', 'county');
const mitreCmmiMetrics = pophealthFact('mitre-cmmi-metrics', ['fips', 'cbsa', 'state_fips'], 'cmmi-metrics');
const npcrCancer = pophealthFact('npcr-cancer', ['fips', 'state_fips']);
const providerInteroperability = pophealthFact('provider-interoperability', ['cbsa']);
const sahie = pophealthFact('sahie', ['fips', 'state_fips']);
const stateMarketConcentration = pophealthGeoFact('state-market-concentration', 'state');
exports.default = [
    acsPopulation,
    apmMetrics,
    brfss,
    cbsaMarketConc,
    crBenchmarks,
    countyMarketConc,
    crmCd,
    biCrmCd,
    crmCounty,
    biCrmCounty,
    crmNational,
    biCrmNational,
    crmState,
    biCrmState,
    medicareCostVariation,
    medicareGeoVariation,
    mitreCmmiMetrics,
    npcrCancer,
    providerInteroperability,
    sahie,
    stateMarketConcentration,
];
